import React from 'react';

import { Footer, Header } from '$partials/global';
import { Media, SimpleImage } from '$partials/media';
import { ModuleDispatcher } from '$partials/modules';
import { CtaBannerBlock } from '$partials/modules/blocks';
import { LandingSchema } from '$partials/landing';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 *
 * @type {import('$types/components/pages').LandingPage}
 */
const LandingPage = (props) => {
    const page = props.data.page;

    return (
        <>
            <LandingSchema
                page={page}
                url={props?.location} />

            <Header {...props.data.header} />

            <main id='main-content'>
                <header className='theme-light-alt bg-main-background'>
                    <div className='layout-container layout-site-outer-padding pt-[76px] sm:pt-[92px] md:pt-160 pb-24 sm:pb-40 md:pb-48'>
                        <h1 className='text-main-text-primary type-style-1'>
                            {page?.title}
                        </h1>
                    </div>

                    {page?.coverMedia &&
                        <>
                            {page?.coverMedia?.image &&
                                <SimpleImage
                                    {...page.coverMedia.image}
                                    className='w-full h-[245px] sm:h-[540px] md:h-[810px] object-cover' />
                            }
                            {page?.coverMedia?.video &&
                                <video
                                    autoPlay={true}
                                    className='w-full h-[245px] sm:h-[540px] md:h-[810px] object-cover'
                                    loop={true}
                                    muted={true}
                                    poster={page.coverMedia.video.poster?.url}
                                    src={page.coverMedia.video.src} />
                            }
                        </>
                    }
                </header>

                <section className='theme-light-alt'>
                    {page?.modules.map((module, i) => (
                        <ModuleDispatcher
                            {...module}
                            key={i + module?.id} />
                    ))}
                </section>
            </main>
            <CtaBannerBlock
                body={page.getInTouchBodyTextOverride || props.data.footer?.getInTouchBodyText}
                heading={page.getInTouchHeadingTextOverride || props.data.footer?.getInTouchHeadingText}
                opensDialog={true}/>
            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default LandingPage;
